
export let setCargoCarrierTypes = (state, cargoCarrierTypesDto) => {
	state.cargoCarrierTypes = cargoCarrierTypesDto;
};

export function set(state, fn) {
	if (fn)
		fn(state);
}

function setErrors(state, { errors, id }) {
	if (!errors)
		return;

	state.errors.iconId = errors.invalidIconId || false;

	state.errors.id = id ? id : '';
}

function clearErrors(state) {

	state.errors.iconId = false;

	state.errors.id = '';
}


export default {
	setCargoCarrierTypes,
	set,
	setErrors,
	clearErrors,
};
